import { sendRequest } from "@infrastructure/api/api";
import ApiResponse from "@core/types/apiResponse";
import { ApiMessageResponse } from "@core/types/apiMessageResponse";
import {
    FinanceAllocationRuleResponse,
    FinanceAllocationRuleKpi,
} from "@features/admin/finance/allocation-rule/types/financeAllocationRule";
import {
    CreateFinanceAllocationRuleRequest,
    UpdateFinanceAllocationRuleRequest,
} from "@features/admin/finance/allocation-rule/types/financeAllocationRuleRequests";

const toQueryParams = (params: Record<string, any>): Record<string, string> => {
    const result: Record<string, string> = {};
    for (const [key, value] of Object.entries(params)) {
        if (value === undefined || value === null) continue;
        result[key] = typeof value === "boolean" ? (value ? "1" : "0") : String(value);
    }
    return result;
};

export const fetchAllocationRuleTemplateKpis = async (
    nationId: number
): Promise<ApiResponse<FinanceAllocationRuleKpi[]>> => {
    return sendRequest<never, FinanceAllocationRuleKpi[]>(
        "GET",
        `nation/${nationId}/finance/allocation-rule/template-kpis`
    );
};

export const fetchFinanceAllocationRules = async (
    nationId: number,
    params: any
): Promise<ApiResponse<FinanceAllocationRuleResponse>> => {
    return sendRequest<never, FinanceAllocationRuleResponse>(
        "GET",
        `nation/${nationId}/finance/allocation-rule/query?${new URLSearchParams(toQueryParams(params))}`
    );
};

export const createFinanceAllocationRule = async (
    nationId: number,
    data: CreateFinanceAllocationRuleRequest
): Promise<ApiResponse<ApiMessageResponse>> => {
    return sendRequest<CreateFinanceAllocationRuleRequest, ApiMessageResponse>(
        "POST",
        `nation/${nationId}/finance/allocation-rule/create`,
        data
    );
};

export const updateFinanceAllocationRule = async (
    nationId: number,
    ruleGroupId: number,
    data: UpdateFinanceAllocationRuleRequest
): Promise<ApiResponse<ApiMessageResponse>> => {
    return sendRequest<UpdateFinanceAllocationRuleRequest, ApiMessageResponse>(
        "POST",
        `nation/${nationId}/finance/allocation-rule/${ruleGroupId}/update`,
        data
    );
};

export const disableFinanceAllocationRule = async (
    nationId: number,
    ruleGroupId: number
): Promise<ApiResponse<ApiMessageResponse>> => {
    return sendRequest<never, ApiMessageResponse>(
        "POST",
        `nation/${nationId}/finance/allocation-rule/${ruleGroupId}/disable`
    );
};

export const enableFinanceAllocationRule = async (
    nationId: number,
    ruleGroupId: number
): Promise<ApiResponse<ApiMessageResponse>> => {
    return sendRequest<never, ApiMessageResponse>(
        "POST",
        `nation/${nationId}/finance/allocation-rule/${ruleGroupId}/enable`
    );
};
